import { useCallback, useEffect, useState } from "react";
import { ClearGeneralForm } from "./ClearGeneralForm";
import axios from "../../../api/apiClient";
import { domain, token } from "../../Security";
import { LoadingSpinner } from "../../../common/Loading";

import CloseIcon from "@mui/icons-material/Close";

export function AddGeneralMemoForm({
  isOpen,
  onClose,
  description,
  date,
  contentMemo,
  files,
  setDescription,
  setDate,
  setContentMemo,
  setFiles,
  setGeneralData,
  handleSubmitMemoCreate,
  handleSubmitMemoUpdate,
  handleSubmitGeneralDelete
}) {
  const [errorState, setErrorState] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const submit = (e) => {
    if (!description
      || !contentMemo
    ) {
      setErrorState(true);
      return;
    }
    if (isCreate) {
      handleSubmitMemoCreate(e);
    } else {
      handleSubmitMemoUpdate(e);
    }
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setDescription("");
    setDate("");
    setContentMemo("");
    setFiles("");
    setGeneralData([]);
    setErrorState(false);
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
  };

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/General";

    try {
      setLoadingRequest(true);
      const response = await axios.get(`${apiUrl}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    } finally {
      setLoadingRequest(false); // Set loading state to false after data fetching is complete
    }
  }, []);

  useEffect(() => {
    const fetchDataGeneral = async () => {
      if (isOpen) {
        const dataGeneral = await fetchData();
        // Handle the fetched data (e.g., update state)
        const foundKey = dataGeneral.find(data => data.key === "Memo");
        let filesToBeSet = [];

        if (foundKey) {
          setGeneralData(foundKey);
          setIsCreate(false);
          setDescription(foundKey.title);
          setContentMemo(foundKey.description);

          if (foundKey.content) {
            const binaryData = atob(foundKey.content);

            // Convert the binary data to a Uint8Array
            const arrayBuffer = new ArrayBuffer(binaryData.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryData.length; i++) {
              uint8Array[i] = binaryData.charCodeAt(i);
            }

            const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

            const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

            filesToBeSet.push(file);
          }

          setFiles(filesToBeSet)
        } else {
          setIsCreate(true);
        }
      }
    };

    fetchDataGeneral();
  }, [fetchData, isOpen, setDescription, setContentMemo, setFiles, setGeneralData]);

  const closeClearForm = () => {
    setShowDeleteForm(false);
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add General Memo</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Description</div>
                <div className="info-item-input">
                  <input
                    id="description"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !description && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Content</div>
                <div className="info-item-input">
                  <textarea id="overtime-tamper"
                    style={{ width: "95%", minHeight: "100px", borderRadius: "3px", border: "1px solid #80808080", color: "rgb(104, 104, 104)" }}
                    value={contentMemo}
                    onChange={(e) => setContentMemo(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !contentMemo && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className='browse'>Browse...</label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: 'none' }}
                  />

                  {files.length > 0 ? (
                    <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{ width: "150px", height: "auto" }}></img>
                        ))}
                      </ul>
                      <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                        <button id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}>
                          CLEAR
                        </button>
                      </div>
                    </div>
                  )
                    :
                    (
                      <div
                        id='drop-files-here'
                        onDrop={(e) => handleDrop(e)}
                        onDragOver={(e) => handleDragOver(e)}
                        onDragLeave={(e) => handleDragOut(e)}
                        style={{
                          border: '2px dashed #ccc',
                          borderRadius: '5px',
                          padding: '20px',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      >
                        Drop files here
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="cancel row"
                onClick={() => setShowDeleteForm(true)}
                style={{ marginRight: "5px", borderRadius: "3px", height: "34px" }}>
                CLEAR
              </button>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
      <ClearGeneralForm isOpen={showDeleteForm} onClose={closeClearForm} handleDelete={handleSubmitGeneralDelete} />
      <LoadingSpinner loading={loadingRequest} />
    </>
  );
}
